function myShippingFunction()
{
  var rateConversion = Shopify.currency.rate;
  var usdPrice = parseInt(document.querySelector('#usdPrice').textContent);
  var shippingPrice = rateConversion*usdPrice;
  var formattedShippingPrice = Shopify.formatMoney(shippingPrice, Shopify.money_format);
   
 $.ajax({
 url: "/cart.js",
 type: 'GET',
 dataType: 'json',
 success: function(res) {

   if(typeof(lastReward) != "undefined")
   {
  if(res.original_total_price >= lastReward && addGift){
    if(!res.items.some(item => item.id === 42185242378436)){
      document.querySelector(".cart-gamification form button").click()
    }
  }
   }
   
 var cartPrice = res.total_price;
 var formatedCartPrice = Shopify.formatMoney(cartPrice, Shopify.money_format);
 var pending = shippingPrice - cartPrice;
 var pendingPriceFormat = Shopify.formatMoney(pending, Shopify.money_format);
 var percentage = (cartPrice/shippingPrice)*100;
 if(percentage<0){percentage=0}else if(percentage>100){percentage=100}

  if(document.querySelector('.shipping-bar p.stillPending strong.gd-free-shipping-bar-number'))
    document.querySelector('.shipping-bar p.stillPending strong.gd-free-shipping-bar-number').textContent = pendingPriceFormat.replace('<span class=money>','').replace('</span>','');

  if(pending<=0)
  {
   //completion
  if(document.querySelector('.shipping-bar'))
  document.querySelector('.shipping-bar').classList.add('completed')
  }else{
    if(document.querySelector('.shipping-bar'))
    document.querySelector('.shipping-bar').classList.remove('completed')
  }
   
if(document.querySelector('cart-drawer .progress .bar'))
  document.querySelector('cart-drawer .progress .bar').style.width=percentage+"%";

if(document.querySelector('cart-drawer .shipping-bar'))
  document.querySelector('cart-drawer .shipping-bar').classList.remove('loading')

console.log('Shipping bar updated!');
 }
               
 });
      
}


document.addEventListener("DOMContentLoaded", (event) => {
myShippingFunction();
});



class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);

        myShippingFunction();
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
  
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });

    if(typeof(myShippingFunction) == "function")
{
    myShippingFunction()
}
    
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);







 


